"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextPane = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("../../styles/context");
const constants_1 = require("../../constants");
const paneClass = (0, nano_theme_1.drule)({
    d: 'inline-block',
    pos: 'relative',
    z: constants_1.ZINDEX.CONTEXT,
    lh: '1.2em',
    l: 'auto',
    r: 0,
    bdrad: '8px',
    trs: 'transform .45s cubic-bezier(.2,2,0,1), opacity .3s',
});
const bodyClass = (0, nano_theme_1.rule)({
    pos: 'relative',
    zIndex: 2,
    bdrad: '4px',
});
const triangleClass = (0, nano_theme_1.drule)({
    pos: 'absolute',
    zIndex: 1,
    w: '7px',
    h: '7px',
    t: '2px',
    transform: 'rotate(45deg) translate(-5px,-5px)',
    borderTopLeftRadius: '2px',
});
exports.ContextPane = React.forwardRef(({ children, right, triangle, canOverflow, minWidth, hide, style, accent, transparent, borderless, lite, inline, className, ...rest }, ref) => {
    const styles = (0, context_1.useStyles)();
    const light = styles.light;
    const shade = light ? 0 : 0.3;
    const triangleShade = 0;
    const triangleBg = light ? '#fff' : styles.g(0.98);
    const paneCls = paneClass({
        bdt: `1px solid ${styles.g(shade, 0.1)}`,
        bdl: `1px solid ${styles.g(shade, 0.2)}`,
        bdr: `1px solid ${styles.g(shade, 0.15)}`,
        bdb: `1px solid ${styles.g(shade, 0.25)}`,
        '&:hover': {
            bdt: `1px solid ${styles.g(shade, 0.2)}`,
            bdl: `1px solid ${styles.g(shade, 0.3)}`,
            bdr: `1px solid ${styles.g(shade, 0.25)}`,
            bdb: `1px solid ${styles.g(shade, 0.35)}`,
        },
    });
    const triangleCls = triangleClass({
        bdl: `1px solid ${styles.g(triangleShade, 0.15)}`,
        bdt: `1px solid ${styles.g(triangleShade, 0.15)}`,
        bdr: `1px solid ${triangleBg}`,
        bdb: `1px solid ${triangleBg}`,
        bg: triangleBg,
        bxsh: `0 -1px 1px ${styles.g(triangleShade, 0.035)}`,
    });
    const blockStyle = {
        background: transparent ? 'transparent' : light ? styles.bg + '' : styles.g(0.94),
        color: styles.g(0.2),
        boxShadow: transparent || borderless
            ? 'none'
            : lite
                ? '0 1px 2px rgba(9,30,66,.06),0 0 4px rgba(9,30,66,.04),0 0 1px rgba(9,30,66,.08)'
                : '0 4px 8px -2px rgba(9,30,66,.25),0 0 13px rgba(9,30,66,.13),0 0 1px rgba(9,30,66,.2)',
        ...(style || {}),
        border: transparent || borderless ? 'none' : undefined,
    };
    if (minWidth) {
        blockStyle.minWidth = minWidth;
    }
    if (!right) {
        blockStyle.left = 0;
        blockStyle.right = 'auto';
    }
    if (hide !== undefined) {
        blockStyle.transform = hide ? 'scale(.85)' : 'scale(1)';
        blockStyle.opacity = hide ? 0 : 1;
    }
    if (accent) {
        blockStyle.borderBottom = `2px solid ${accent}`;
    }
    if (inline) {
        blockStyle.position = 'static';
        blockStyle.zIndex = 'auto';
    }
    return (React.createElement("div", { ...rest, className: paneCls + (className || ''), style: blockStyle, ref: ref },
        React.createElement("div", { className: bodyClass, style: { overflow: canOverflow ? 'visible' : undefined } }, children),
        triangle && (React.createElement("div", { className: triangleCls, style: {
                left: right ? 'auto' : 15,
                right: right ? 15 : 'auto',
            } }))));
});
